<template>
    <header class="z-2 g-header" :class="{
      'home-logo-align': routeName === 'home',
      'home-logo-hidden': hasHomeLogo,
      'header-orbital-align' : routeName === 'orbital-show',
      'header-logo-gallery' : routeName === 'front-gallery'
    }">
        <div class="header--custom" :class="routeName ==='contact' ? 'contact-logo-align' : ''">
            <router-link v-if="withMenu" :to="logoLink" class="logo">
                <div class="logo--wrapper">
                    <img :src="mainLogo " class="first--logo" alt="">
                </div>
                <span v-if="mainLogo && ((headerOrbital || secondaryLogo ) && routeName !== 'home')" class="line"></span>
                <div class="logo--wrapper" v-if="secondaryLogo">
                    <img :src="secondaryLogo " class="first--logo" alt="">
                </div>
                <div v-else class="logo--wrapper logo-subtitle" v-if="routeName !== 'home'" v-html="headerOrbital" />
            </router-link>
            <template v-else>
                <router-link v-if="shouldLinkToMainModel" :to="logoLink" class="logo">
                    <div class="logo--wrapper">
                        <img :src="mainLogo" class="first--logo" alt="">
                    </div>
                    <span v-if="mainLogo && (headerOrbital && routeName !== 'home')" class="line"></span>
                    <div class="logo--wrapper logo-subtitle" v-if="routeName !== 'home'" v-html="headerOrbital" />
                </router-link>
                <div v-else class="logo">
                    <div class="logo--wrapper">
                        <img :src="mainLogo" class="first--logo" alt="">
                    </div>
                    <span v-if="mainLogo && (headerOrbital && routeName !== 'home')" class="line"></span>
                    <div class="logo--wrapper logo-subtitle" v-if="routeName !== 'home'" v-html="headerOrbital" />
                </div>
            </template>

            <LangSwitcher v-if="isLangsEnabled"/>

            <slot name="orbital-nav"></slot>

            <span v-if="withMenu && routeName !== 'home'" class="hamburger material-icons" @click.prevent="handleOpenMenu">
                <svg xmlns="http://www.w3.org/2000/svg" width="31" height="21" viewBox="0 0 31 21">
                  <g id="Groupe_9" data-name="Groupe 9" transform="translate(-259.5 -31)">xX
                    <line id="Ligne_1" data-name="Ligne 1" x2="31" transform="translate(259.5 31.5)" fill="none"
                          stroke="#000" stroke-width="1"/>
                    <line id="Ligne_2" data-name="Ligne 2" x2="31" transform="translate(259.5 41.5)" fill="none"
                          stroke="#000" stroke-width="1"/>
                    <line id="Ligne_3" data-name="Ligne 3" x2="31" transform="translate(259.5 51.5)" fill="none"
                          stroke="#000" stroke-width="1"/>
                  </g>
                </svg>
            </span>

            <nav class="nav-drill">
                <div class="close" @click.prevent="handleCloseMenu">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21.69" height="20.724" viewBox="0 0 21.69 20.724">
                        <g id="Groupe_9" data-name="Groupe 9" transform="translate(-258.959 -31.138)">
                            <line id="Ligne_1" data-name="Ligne 1" x2="21" y2="20" transform="translate(259.304 31.5)" fill="none" stroke="#fff" stroke-width="1"/>
                            <line id="Ligne_3" data-name="Ligne 3" y1="20" x2="21" transform="translate(259.304 31.5)" fill="none" stroke="#fff" stroke-width="1"/>
                        </g>
                    </svg>
                </div>
                <ul class="nav-items">
                    <li v-if="isCycloramaAvailable" class="nav-item">
                        <router-link :to="{ name: 'cyclorama', params: { locale: $store.state.config.locale }, query: {} }" class="nav-link">
                            Cyclorama
                        </router-link>
                    </li>
                    <li v-if="isOrbitalPageAvailable" class="nav-item">
                        <router-link :to="{ name: 'orbital-show', params: { locale: $store.state.config.locale }, query: {} }" class="nav-link">
                            Maquette Orbitale
                        </router-link>
                    </li>
                    <li v-if="isVirtualTourAvailable" class="nav-item">
                        <a class="nav-link subnav--vv cursor-pointer" @click.prevent="handleVTourLinkClick">
                            Visites Virtuelles
                        </a>
                        <ul class="text-white display--submenu--vv" v-show="isTourMenuOpen">
                            <span class="vv--submenu-wrapper">
                              <span class="vv--submenu-top">
                                  <li v-if="domain && domain.tours && domain.tours.data && domain.tours.data[0]" class="hover:opacity-75">
                                      <router-link :to="{ name: 'virtual-tour', params: { locale: $store.state.config.locale, tour : 1 } }" @click="handleCloseMenu">
                                          <span>{{ domain.tours.data[0].name }}</span>
                                          <img :src="domain.tours.data[0].thumb ? domain.tours.data[0].thumb.url : 'https://via.placeholder.com/150'" alt="">
                                      </router-link>
                                  </li>
                                  <li v-if="domain && domain.tours && domain.tours.data && domain.tours.data[1]" class="hover:opacity-75">
                                      <router-link :to="{ name: 'virtual-tour', params: { locale: $store.state.config.locale, tour : 2 } }" @click="handleCloseMenu">
                                          <span>{{ domain.tours.data[1].name }}</span>
                                          <img :src="domain.tours.data[1].thumb ? domain.tours.data[1].thumb.url : 'https://via.placeholder.com/150'" alt="">
                                      </router-link>
                                  </li>
                              </span>
                              <span class="vv--submenu-bottom">
                              <li v-if="domain && domain.tours && domain.tours.data && domain.tours.data[2]" class="hover:opacity-75">
                                      <router-link :to="{ name: 'virtual-tour', params: { locale: $store.state.config.locale, tour : 3 } }" @click="handleCloseMenu">
                                          <span>{{ domain.tours.data[2].name }}</span>
                                          <img :src="domain.tours.data[2].thumb ? domain.tours.data[2].thumb.url : 'https://via.placeholder.com/150'" alt="">
                                      </router-link>
                                  </li>
                                  <li v-if="domain && domain.tours && domain.tours.data && domain.tours.data[3]" class="hover:opacity-75">
                                      <router-link :to="{ name: 'virtual-tour', params: { locale: $store.state.config.locale, tour : 4 } }" @click="handleCloseMenu">
                                          <span>{{ domain.tours.data[3].name }}</span>
                                          <img :src="domain.tours.data[3].thumb ? domain.tours.data[3].thumb.url : 'https://via.placeholder.com/150'" alt="">
                                      </router-link>
                                  </li>
                              </span>
                            </span>
                        </ul>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" :to="{ name: 'front-gallery', params: { locale: $store.state.config.locale } }">
                            Galerie
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" :to="{ name: 'video', params: { locale: $store.state.config.locale } }">
                            Vidéo
                        </router-link>
                    </li>
                    <li v-if="isContactPageAvailable" class="nav-item">
                        <router-link class="nav-link" :to="{ name: 'contact', params: { locale: $store.state.config.locale } }">
                            Contact
                        </router-link>
                    </li>
                </ul>
            </nav>
        </div>
    </header>

</template>

<script>
import {directive} from "vue3-click-away";
import LangSwitcher from "./partials/lang-switcher.vue";
import { isPageActive } from "../composables/pages";

export default {
    data() {
        return {
            appUrl: process.env.MIX_APP_URL,
            pages: [],
            isTourMenuOpen: false,
        }
    },
    props: {
        floors: Array,
        project: Object,
        building: Object,
    },
    computed: {
        domain() {
            return this.$store.state.frontoffice.domain;
        },
        isCycloramaAvailable() {
            return this.$store.state.frontoffice.isCycloramaAvailable;
        },
        isVirtualTourAvailable() {
            return this.$store.state.frontoffice.isVirtualTourAvailable;
        },
        isOrbitalPageAvailable() {
            return isPageActive(this.domain?.pages?.data, 'orbital');
        },
        mainLogo() {
            // Si on est sur une page d'orbital et qu'on a un building avec un logo
            if (this.routeName === 'orbital-show' && this.building && this.building.settings && this.building.settings.data && this.building.settings.data.length > 0) {
                const buildingLogoSetting = this.building.settings.data.find(setting => setting.name === 'building-logo');

                if (buildingLogoSetting && buildingLogoSetting.image) {
                    return buildingLogoSetting.image.url;
                }
            }

            // Logique existante pour le logo du domaine
            if(this.domain) {
                if(window.innerWidth <= 1100 && Array('orbital', 'cyclorama', 'home', 'vtour').includes(this.$route.name)) {
                    if(this.domain.settings.data.find( setting => setting.name === 'upper-left-logo-neg' ) && this.domain.settings.data.find( setting => setting.name === 'upper-left-logo' ).image) {
                        return this.domain.settings.data.find( setting => setting.name === 'upper-left-logo-neg' ).image.url
                    }
                }

                if(this.domain.pages.data && this.domain.pages.data.find( page => page.name === this.$route.name) && this.domain.pages.data.find( page => page.name === this.$route.name).withAltLogo) {
                    if(this.domain.settings.data.find( setting => setting.name === 'upper-left-logo-neg' ) && this.domain.settings.data.find( setting => setting.name === 'upper-left-logo' ).image) {
                        return this.domain.settings.data.find( setting => setting.name === 'upper-left-logo-neg' ).image.url
                    }
                }else {
                    if(this.domain.settings.data.find( setting => setting.name === 'upper-left-logo' ) && this.domain.settings.data.find( setting => setting.name === 'upper-left-logo' ).image) {
                        return this.domain.settings.data.find( setting => setting.name === 'upper-left-logo' ).image.url
                    }
                }
            }

            return process.env.MIX_APP_URL + '/img/logo.png';

        },
        secondaryLogo() {
            if(this.domain) {
                if(Array('orbital-show').includes(this.routeName)) {
                    if(this.domain.settings.data.find( setting => setting.name === 'secondary-logo' ) && this.domain.settings.data.find( setting => setting.name === 'secondary-logo' ).image) {
                        return this.domain.settings.data.find( setting => setting.name === 'secondary-logo' ).image.url
                    }
                }
            }
        },
        headerOrbital() {
            if(this.domain && this.domain.settings.data.find( setting => setting.name === 'orbital-title' )) {
                return this.domain.settings.data.find( setting => setting.name === 'orbital-title' ).value
            }

            return null;
        },
        withFilter() {
            if(this.domain && this.domain.settings.data.find( setting => setting.name === 'with-filter' )) {
                return !!Number(this.domain.settings.data.find( setting => setting.name === 'with-filter' ).value)
            }

            return false
        },
        withMenu() {
            if(this.domain && this.domain.settings.data.find( setting => setting.name === 'with-menu' )) {
                return !!Number(this.domain.settings.data.find( setting => setting.name === 'with-menu' ).value)
            }

            return true
        },
        routeName() {
            return this.$route.name;
        },
        // Same width split as the home page logo in Home.vue.
        hasHomeLogo() {
            if(this.routeName !== 'home' || !this.domain) {
                return false
            }

            const homeLogoName = window.innerWidth >= 1000 ? 'black-logo' : 'white-logo'

            return !!this.domain.settings.data.find( setting => setting.name === homeLogoName )?.image
        },
        isContactPageAvailable() {
            if(this.domain?.pages.data && this.domain?.pages.data.find( page => page.name === 'contact')) {
                return !!Number(this.domain?.pages.data.find( page => page.name === 'contact').is_active)
            }

            return true;
        },
        isLangsEnabled() {
            if(this.domain && this.domain.settings.data.find( setting => setting.name === 'langs-enabled' )) {
                return !!Number(this.domain.settings.data.find( setting => setting.name === 'langs-enabled' ).value)
            }

            return false;
        },
        shouldLinkToMainModel() {
            return this.building && this.building.building_id !== null && this.routeName === 'orbital-show';
        },
        logoLink() {
            if (this.shouldLinkToMainModel) {
                return { name: 'orbital-show', query: {}, params: { locale: this.$store.state.config.locale } };
            }
            return { name: 'home', params: { locale: this.$store.state.config.locale } };
        }
    },
    methods: {
        handleOpenMenu() {
            document.querySelector("body").classList.add('nav-is-toggled');
            document.querySelector("header").classList.add('nav-is-toggled-header');
            document.querySelector("body").addEventListener("click", () => {
                if (event.target === document.querySelector("body")) {
                    this.handleCloseMenu()
                }
            })
        },
        handleCloseMenu() {
            document.querySelector("body").classList.remove('nav-is-toggled');
            document.querySelector("header").classList.remove('nav-is-toggled-header');

            if(document.querySelector(".subnav--vv")) {
                document.querySelectorAll(".subnav--vv").forEach( (element) => element.classList.remove("active--color") )
            }

            if(document.querySelector("ul.display--submenu--vv")) {
                document.querySelectorAll("ul.display--submenu--vv").forEach( (element) => element.style.display = "none")
            }
        },
        handleOpenFilters() {
            this.$emit('openFilters')
        },
        handleOpenControls() {
            this.$emit('openControls')
        },
        handleVTourLinkClick(e) {
            e.target.classList.add("active--color")
            document.querySelectorAll("ul.display--submenu--vv").forEach( (element) => element.style.display = "flex")
            document.querySelector("body").append(document.querySelector("ul.display--submenu--vv"));

            const headerNav = document.querySelector(".nav-drill");
            if(headerNav) {
              headerNav.classList.add('tour--is-active');
            }
        },
        handleResetCurrentUnit() {
            this.$emit('resetCurrentUnit')
        }
    },
    directives: {
        ClickAway: directive
    },
    components: {
        LangSwitcher
    }
}
</script>
